// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + ({"127":"search-modal","764":"markdown"}[chunkId] || chunkId) + "-" + {"69":"a1b67e8665768da25bb3","127":"b9685e217f6a11c4918c","764":"f5fe6f8b67c528c88747"}[chunkId] + ".chunk.js";
};